import { getFileName } from "@helpers/getFileName"
import { useQuery } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { endpoints, PlantWeatherSensorIds } from "api"

export function useListOfWeatherSensorsQuery(args: { plantId: number }) {
	const enabled = args.plantId !== -1

	const res = useQuery({
		queryKey: [
			`source=${getFileName()}`,
			`queryId=ListOfWeatherSensors`,
			`endpoints=[${endpoints.weatherGetPlantSensorIds.getName()}]`,
			`plantId=${args.plantId}`,
		],
		queryFn: async (): Promise<PlantWeatherSensorIds> => {
			if (enabled === false) {
				throw new Error("useListOfWeatherSensorsQuery requires a valid plantId parameter")
			}
			const response = await requestApi2(endpoints.weatherGetPlantSensorIds, {
				plantId: args.plantId,
			})

			return response !== null
				? response
				: {
						relativeWindDirection: null,
						relativeWindSpeed: null,
						trueWindDirection: null,
						trueWindSpeed: null,
						waveHeightM: null,
						waterTempC: null,
						waveDirectionDeg: null,
						windWavePeriodSec: null,
						windWaveHeight: null,
						currentDirectionDeg: null,
						currentSpeedMps: null,
						airTemperature: null,
						wavePeriodSec: null,
						windWaveDirectionDeg: null,
						humidityPercent: null,
						stormglassWindDirection: null,
						stormglassWindSpeed_mps: null,
					}
		},
		enabled,
		staleTime: 10 * 60 * 1000,
		refetchInterval: 10 * 60 * 1000,
	})
	return res
}
